module.exports = __webpack_public_path__ + "assets/8049d9d247cdd887c4cb14c978d4c1ce.png";